import React from "react";
import { Link } from "react-router-dom";
import { toAbsoluteUrl } from "../../../_helpers";

export function Brand() {
  return (
    <>
      {/* begin::Brand */}
      <div>
        {/* begin::Logo */}
        <Link to="/" className="brand-logo">
          <img
            alt="logo"
            height={"24px"}
            src={toAbsoluteUrl("/media/svg/logo.svg")}
            className="max-h-40px"
          />
        </Link>
        {/* end::Logo */}
      </div>
      {/* end::Brand */}
    </>
  );
}
